import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  const features = [
    { name: 'Inventory Management', link: '/features/inventory' },
    { name: 'Prescription Manager', link: '/features/prescriptions' },
    { name: 'Sales & Reports', link: '/features/reports' },
    { name: 'Supplier Management', link: '/features/suppliers' },
  ];

  const solutions = [
    { name: 'For Pharmacy Owners', link: '/solutions/pharmacy-owners' },
    { name: 'For Clinics', link: '/solutions/clinics' },
    { name: 'For Hospitals', link: '/solutions/hospitals' },
    { name: 'For Distributors', link: '/solutions/distributors' },
  ];

  const resources = [
    { name: 'Blog', link: '/blog' },
    { name: 'FAQ', link: '/faq' },
    { name: 'Contact', link: '/contact' },
    { name: 'Security', link: '/security' },
  ];

  return (
    <nav className="public-navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">🏥 PharmacyHub</Link>
        <div className="nav-links">
          <div className="nav-dropdown" onMouseEnter={() => toggleDropdown('features')} onMouseLeave={() => toggleDropdown(null)}>
            <button className="nav-link">Features</button>
            {openDropdown === 'features' && (
              <div className="dropdown-menu">
                {features.map(item => (
                  <Link key={item.link} to={item.link} className="dropdown-item">{item.name}</Link>
                ))}
              </div>
            )}
          </div>
          <div className="nav-dropdown" onMouseEnter={() => toggleDropdown('solutions')} onMouseLeave={() => toggleDropdown(null)}>
            <button className="nav-link">Solutions</button>
            {openDropdown === 'solutions' && (
              <div className="dropdown-menu">
                {solutions.map(item => (
                  <Link key={item.link} to={item.link} className="dropdown-item">{item.name}</Link>
                ))}
              </div>
            )}
          </div>
          <Link to="/pricing" className="nav-link">Pricing</Link>
          <div className="nav-dropdown" onMouseEnter={() => toggleDropdown('resources')} onMouseLeave={() => toggleDropdown(null)}>
            <button className="nav-link">Resources</button>
            {openDropdown === 'resources' && (
              <div className="dropdown-menu">
                {resources.map(item => (
                  <Link key={item.link} to={item.link} className="dropdown-item">{item.name}</Link>
                ))}
              </div>
            )}
          </div>
          <Link to="/contact" className="nav-link">Contact</Link>
        </div>
        <div className="nav-buttons">
          <Link to="/login" className="btn-login">Login</Link>
          <Link to="/register" className="btn-register">Register</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;